import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Storage } from '@ionic/storage';

import { Insomnia } from '@ionic-native/insomnia';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  user_api_hash = undefined;
  currentPage: any = 'SplashPage';
  rootPage: any = 'SplashPage';

  pages: Array<{ icon: string, title: string, component: any }>;

  constructor(
    public events: Events,
    private insomnia: Insomnia,
    public storage: Storage,
    private platform: Platform,
    public alertCtrl: AlertController,
    statusBar: StatusBar,
    splashScreen: SplashScreen
  ) {

    events.subscribe('menu:render', (user_api_hash) => {
      this.user_api_hash = user_api_hash;
      this.pages = [
        { title: 'Veículos', component: 'ListVeiculosPage', icon: 'md-car' },
        { title: 'Histórico', component: 'HistoricoPage', icon: 'calendar' },
        { title: 'Alertas', component: 'AlertasPage', icon: 'notifications' },
        // { title: 'Notificações', component: 'NotificacoesPage', icon: 'alert' },
        // { title: 'Cominucados', component: 'ComunicadoPage', icon: 'megaphone' },
        { title: 'Compartilhar', component: 'CompartilharVeiculoPage', icon: 'share' },
        { title: 'Mensalidades', component: 'PagarMensalidadePage', icon: 'logo-usd' },
        { title: 'Perfil', component: 'PerfilPage', icon: 'contact' },
        { title: 'Trocar senha', component: 'SenhaPage', icon: 'lock' },
        { title: 'Ajuda', component: 'AjudaPage', icon: 'help-circle' },
        { title: 'Sobre', component: 'SobrePage', icon: 'alert' },
        { title: 'Sair', component: "logout", icon: 'md-power' }
      ];
      this.currentPage = 'ListVeiculosPage';
    });


    platform.ready().then(() => {
      if (platform.is('ios')) {
        statusBar.styleBlackTranslucent();
      }
      else {
        statusBar.styleLightContent();
        //statusBar.hide();              
      }
      statusBar.backgroundColorByHexString('#222222');
      //splashScreen.hide();
    });
    //Manter tela ligada
    this.insomnia.keepAwake();
  }

  exitApp() {
    if (!this.platform.is('ios')) {
      this.platform.exitApp();
    }
  }

  logout() {
    var confirm = this.alertCtrl.create({
      title: 'Sair do Sistema',
      message: 'Deseja realmente sair do sistema?',
      buttons: [
        {
          text: 'Não',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.storage.remove('user_api_hash');
            this.storage.remove('email_usuario');
            this.storage.remove('password_usuario');
            this.storage.remove('lembra_senha_usuario');
            this.storage.remove('alertas_visto');
            //this.storage.clear();
            this.nav.setRoot('LoginPage');
          }
        }
      ]
    });
    confirm.present();
  }

  openPage(page) {
    if (page.component == "logout") {
      this.logout();
      return true;
    }
    else {
      if (this.currentPage == page.component) {
        return true;
      }
      else {
        this.currentPage = page.component;
      }
    }

    this.nav.setRoot(page.component, { user_api_hash: this.user_api_hash, root: true });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts